import gql from 'graphql-tag';
import { graphql } from '@apollo/react-hoc';
import { SimpleLoadingComponent } from '../../utils/apollo';

import RepVisitsUpgradeForm from './repvisits-upgrade-form';

const query = gql`
  query RepVisitsUpgradeFormComponent {
    viewer {
      id
      firstName
      lastName
      uuid
      email
      enabledFeatures
      institution {
        id
        name
        field_country
        field_state_short_name
      }
    }
  }
`;

export default SimpleLoadingComponent(graphql(query))(RepVisitsUpgradeForm);
